import _ from 'lodash';

const processStrategy = (devicesPositionHistory) => {
  const relations = {};
  const omit = [];
  return {
    ..._.omit(devicesPositionHistory, omit),
    ..._.pickBy(relations, _.identity),
  };
};

export default {
  key: 'devicesPositionHistory',
  definition: {},
  processStrategy,
};
